import React from "react";

export const Navigation = (props) => {
  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <a className="navbar-brand page-scroll" href="#page-top">
            MARJAN SIKORA PhD
          </a>{" "}
        </div>
        <div
          className=" collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            <li>
              <a href="#research" className="page-scroll">
                Research
              </a>
            </li>
            <li>
              <a href="#profServ" className="page-scroll">
                Professional
              </a>
            </li>
            <li>
              <a href="#teaching" className="page-scroll">
                Teaching
              </a>
            </li>
            <li>
              <a href="#bioNote" className="page-scroll">
                Bio
              </a>
            </li>
            <li>
              <a href="#contact" className="page-scroll">
                Contact
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
